import { CardBody, CardWrapper } from 'cdk-radial';
import styled from 'styled-components';

export const CustomCardWrapper = styled(CardWrapper)`
  margin: 0;
  padding: 0;
  width: 100%;
`;
export const CustomCardBody = styled(CardBody)`
  margin: 0px;
  padding: 0px;
`;
export const CustomCardBodyPlaceHolder = styled.div`
  position: relative;
`;
export const TotalBarSummaryBodyStyle = styled.div`
  display: table-cell;
  vertical-align: middle;
  font-family: Roboto;
  font-weight: 400;
  padding: 15px;
  font-size: 16px;
  i {
    padding-left: 16px;
  }
`;
export const TotalBarSummaryDivider = styled.div`
  display: table-cell;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.12);
`;
export const TotalBarSummaryTitle = styled.div`
  font-size: 12px;
`;

export const TotalBarSummaryBodyHighlight = styled.div`
  display: table-cell;
  vertical-align: middle;
  font-family: Roboto;
  font-weight: 500;
  padding: 15px;
  font-size: 16px;
  color: white;
  background-color: #0557c4;
  i {
    padding-left: 16px;
  }
`;

export const TotalBarSummaryWithTitle = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: row;
  width: 100%;
  box-shadow: none;
  height: 63px;
`;

export const TotalBarTitle = styled.div`
  flex: 1;
  padding: 18px 0 24px 16px;
  color: #000000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const TotalBarSummary = styled.div`
  text-align: right;
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
`;
